import "@/css/preflight.css";
import "@/css/tailwind.css";
import commonDe from "@/lng/de/common.json";
import connectorDe from "@/lng/de/connector.json";
import commonEn from "@/lng/en/common.json";
import connectorEn from "@/lng/en/connector.json";
import { requireNotNull } from "@enymo/ts-nullsafe";
import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import React from "react";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";
import "../sentry";
import Bootstrapper from "./Bootstrapper";

i18next
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            convertDetectedLanguage: lng => {
                const index = lng.indexOf("-");
                return index === -1 ? lng : lng.substring(0, index);
            }
        },
        debug: import.meta.env.VITE_I18N_DEBUG === "true",
        fallbackLng: "en",
        resources: {
            de: {
                translation: {
                    ...commonDe,
                    ...connectorDe
                }
            },
            en: {
                translation: {
                    ...commonEn,
                    ...connectorEn
                }
            }
        },
        react: {
            useSuspense: false
        },
        interpolation: {
            escapeValue: false
        }
    });

createRoot(requireNotNull(document.getElementById("app"))).render(<Bootstrapper />);